import { Injectable, signal } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ApiRepository } from '../../infrastructure/api.repository';

export interface EnumValueItem {
  value: number;
  name: string;
  displayName: string;
}

export interface PropertyRegistryItem {
  propertyRegistry: string;
  value: string;
}

@Injectable({ providedIn: 'root' })
export class EnumCacheService extends ApiRepository {
  private readonly loaded = signal(false);

  readonly appraisalCompanies = signal<EnumValueItem[]>([]);
  readonly appraisalPurposes = signal<EnumValueItem[]>([]);
  readonly propertyRegistries = signal<PropertyRegistryItem[]>([]);

  ensureLoaded(): void {
    if (this.loaded()) return;
    this.loaded.set(true);

    forkJoin({
      companies: this.get<EnumValueItem[]>('/enums/spanishAppraisalCompanies'),
      purposes: this.get<EnumValueItem[]>('/enums/AppraisalPurposes'),
      registries: this.get<PropertyRegistryItem[]>('/enums/propertyRegistries'),
    }).subscribe(({ companies, purposes, registries }) => {
      this.appraisalCompanies.set(companies);
      this.appraisalPurposes.set(purposes);
      this.propertyRegistries.set(registries);
    });
  }

  getAppraisalCompanyLabel(value: string | null | undefined): string {
    if (!value) return '—';
    const found = this.appraisalCompanies().find(c => c.value === Number(value));
    return found?.displayName ?? found?.name ?? '—';
  }

  getAppraisalPurposeLabel(value: string | null | undefined): string {
    if (!value) return '—';
    const found = this.appraisalPurposes().find(p => p.value === Number(value));
    return found?.displayName ?? found?.name ?? '—';
  }
}
